export default __webpack_public_path__ + "9cd4d05cbcf1fa4650228cc7ac7b6172.jpg";